import { createFileRoute, redirect } from "@tanstack/react-router";
import { LoginSearchParams } from "~/features/auth/types";

export const Route = createFileRoute("/(auth)/_auth/")({
  beforeLoad: () => {
    throw redirect({
      to: '/weight-loss',
    })
  },
  validateSearch: (search: Record<string, unknown>): LoginSearchParams => {
    return {
      redirect: search.redirect as string | undefined,
      email: search.email as string | undefined,
      status: search.status as "success" | undefined,
    };
  },
});
